import { styled } from '@acko-tech/building-blocks.ui.common';

export const HeaderWrapper = styled.div`
    display: flex;
    margin-top: 12px;
`;

export const PhoneIconFlex = styled.div`
    display: flex;
    align-items: center;
    margin-right: 8px;
    margin-left: 5px;
`;

export const ModelNameFlex = styled.div`
    display: flex;
    flex: 6;
    align-items: center;
`;

export const ModelName = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #040222;
`;

export const EditFlex = styled.div`
    display: flex;
    flex: 2;
    align-items: center;
    justify-content: flex-end;
`;

export const Edit = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #1c73e8;
    cursor: pointer;
`;

export const Hr = styled.div`
    width: calc(100% + 40px);
    height: 0px;
    border: 1px solid #e7e7f0;
    margin-top: 10px;
    transform: translateX(-20px);
`;
